import {formatSearchInternetToolMessage} from "./search/searchInternet.ts";
import {editOrCreateFileToolMessage} from "./ide/editOrCreateFile.ts";
import {moveOrDeleteToolMessage} from "./ide/moveOrDeleteFile.ts";
import {runTerminalCommand} from "./ide/runTerminalCommand.ts";
import {searchCodebase} from "./ide/searchCodebase.ts";
import {createDocumentToolMessage} from "./document/createDocument.ts";
import {validationErrorToolMessage} from "./general/validationError.ts";
import {gatherContext} from "./general/gatherContext.ts";
import {toolErrorToolMessage} from "./general/toolError.ts";
import {openFileToolMessage, grepToolMessage} from "./ide/grepTools.ts";
import {viewDirectory} from "./ide/viewDirectory.ts";
import {reviewChangesToolMessage} from "./ide/reviewChanges.ts";
import {generateImagesToolMessage} from "./imageGen/generateImages.ts";

export const getToolMessage = (toolId: string, toolName: string, results: any, llmRequestRefs: any) => {
    let toolMessage: any = {
        role: 'tool',
        tool_call_id: toolId,
        tool_name: toolName,
        content: [],
        truncatedContent: []
    }

    if (results.errorMessage && toolName !== 'validationError') {
        return toolErrorToolMessage(toolMessage, results);
    }

    switch (toolName) {
        case 'searchInternet':
            toolMessage = formatSearchInternetToolMessage(toolMessage, results, llmRequestRefs);
            break;
        case 'createPdf':
        case 'createDocx':
            toolMessage = createDocumentToolMessage(toolMessage, results, toolName);
            break;
        case 'editFile':
        case 'createFile':
            toolMessage = editOrCreateFileToolMessage(toolMessage, results, toolName);
            break;
        case 'deleteFile':
        case 'moveFile':
            toolMessage = moveOrDeleteToolMessage(toolMessage, results, toolName);
            break;
        case 'runTerminalCommand':
            toolMessage = runTerminalCommand(toolMessage, results, toolName);
            break;
        case 'searchCodebase':
            toolMessage = searchCodebase(toolMessage, results);
            break;
        case 'gatherContext':
        case 'deepResearch':
            toolMessage = gatherContext(toolMessage, results);
            break;
        case 'validationError':
            toolMessage = validationErrorToolMessage(toolMessage, results);
            break;
        case 'openFile':
            toolMessage = openFileToolMessage(toolMessage, results);
            break;
        case 'grepCodebase':
            toolMessage = grepToolMessage(toolMessage, results);
            break;
        case 'viewDirectory':
            toolMessage = viewDirectory(toolMessage, results);
            break;
        case 'reviewChanges':
            toolMessage = reviewChangesToolMessage(toolMessage, results);
            break;
        case 'generateImages':
            toolMessage = generateImagesToolMessage(toolMessage, results);
            break;
    }

    return toolMessage;
}
